import { Box, CircularProgress } from "@mui/material";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useUserRoles, useUserRolesLoading } from "../auth/UserRolesContext";
import { hasSopKoBottlerAdminAccess } from "../utils/userAccess";

const SopKoBottlerAdminGuard = () => {
  const roles = useUserRoles();
  const rolesLoading = useUserRolesLoading();
  const location = useLocation();

  if (rolesLoading) {
    return (
      <Box sx={{ minHeight: 160, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress size={28} aria-label="Checking access" />
      </Box>
    );
  }

  if (!hasSopKoBottlerAdminAccess(roles)) {
    return <Navigate to="/user-roles/new-request" replace state={{ deniedPath: location.pathname }} />;
  }

  return <Outlet />;
};

export default SopKoBottlerAdminGuard;
